var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3377 9.83953C19.274 9.84447 17.2609 9.20088 15.5828 7.99969V16.3772C15.5822 17.9288 15.108 19.4432 14.2235 20.718C13.339 21.9928 12.0863 22.9672 10.6331 23.5109C9.17985 24.0545 7.59527 24.1416 6.09123 23.7604C4.58718 23.3791 3.23537 22.5478 2.21654 21.3776C1.19771 20.2074 0.560427 18.754 0.389909 17.2118C0.219391 15.6696 0.523764 14.112 1.26233 12.7475C2.00089 11.3829 3.13844 10.2764 4.52288 9.5758C5.90731 8.87521 7.47263 8.61398 9.00954 8.82703V13.0406C8.30625 12.8194 7.55104 12.8261 6.85176 13.0597C6.15248 13.2933 5.54489 13.7418 5.11577 14.3413C4.68664 14.9408 4.45791 15.6606 4.46225 16.3979C4.4666 17.1351 4.70378 17.8521 5.13995 18.4466C5.57611 19.041 6.18893 19.4824 6.89092 19.7077C7.5929 19.933 8.34813 19.9308 9.04877 19.7013C9.74941 19.4718 10.3596 19.0268 10.7923 18.4298C11.2249 17.8329 11.4578 17.1145 11.4578 16.3772V0H15.5828C15.58 0.348347 15.6091 0.696219 15.67 1.03922C15.8133 1.80491 16.1114 2.53332 16.5459 3.17988C16.9804 3.82643 17.5422 4.37756 18.197 4.79953C19.1286 5.41551 20.2208 5.74383 21.3377 5.74359V9.83953Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.f49f469fb304cf7fe731c95f111c9411.svg";
export { ForwardRef as ReactComponent };